import { ExpandMore } from "@mui/icons-material";
import { useStyle } from "./style";
import { cls } from "itsf-ui-common";

interface IParams {
    className: string;
}

export const SelectIcon = (props: IParams) => {
    const { classes } = useStyle();
    const { className } = props;

    return <ExpandMore className={cls(className, classes.icon)} fontSize="large" />;
};
